var tagsToEncode = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&apos;'
};
var tagsToDecode = Object.entries(tagsToEncode).reduce(function (prev, _a) {
    var key = _a[0], value = _a[1];
    prev[value] = key;
    return prev;
}, {});
/**
 * Encodes text replacing HTML special characters (<>&"')
 *
 * @category Http
 * @param html
 */
export function encodeHtml(html) {
    var re = new RegExp("[" + Object.keys(tagsToEncode).join('') + "]", 'g');
    return html.replace(re, function (value) { return tagsToEncode[value] || value; });
}
/**
 * Decodes text restoring HTML encoded characters (<>&"')
 *
 * @category Http
 * @param html
 */
export function decodeHtml(html) {
    return html.replace(/&[a-z]+;/g, function (value) { return tagsToDecode[value] || value; });
}
